import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { Subject, Observable } from 'rxjs';
import { LocalStorageService } from './local-storage.service';

const backendUrl = environment.backendurl

@Injectable({
  providedIn: 'root'
})
export class VerificationService {

  constructor(private http: HttpClient) { }


  verifyCode(data) {
    const parameter = {
      provider: data.provider,
      code: data.code
    }
    const url = backendUrl + `/user/verifysignupcode?` + GlobalService.urlEncode(parameter);
    return this.http.get(url).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('chaneplan', url)));
  }
  
  sendOtp(data){
    const url = backendUrl + `/user/sendotp`;
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('chaneplan', url)));
  }
  
  verifyOtp(data){
    const url = backendUrl + `/user/verifyotp`;
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('chaneplan', url)));
  }
  
  

}



